<template>
  <div>
    <div>
      <div class="row mt-2 pb-0">
        <div
          class="
            col-md-7
            clearfix
            d-flex
            align-items-center
            justify-content-start
          "
        >
          <h4 class="m-0">Queue:</h4>
        </div>
      </div>
      <div class="row mt-4 pb-2">
        <div class="col-12">
          <base-select-visible
            :per-page="perPage"
            :amounts-shown="amountsShown"
          ></base-select-visible>
        </div>
      </div>
      <div class="dataTables_wrapper container-fluid dt-bootstrap4">
        <generic-sync-v2-table
          :channelId="channelId"
          :paginate="perPage"
          ref="syncTable"
        ></generic-sync-v2-table>
      </div>
      <div class="row mt-2 pb-0">
        <div
          class="
            col-md-7
            clearfix
            d-flex
            align-items-center
            justify-content-start
          "
        >
          <h4 class="m-0">Priorities:</h4>
        </div>
      </div>
      <div>
        <generic-sync-v2-priorities
          :channelId="channelId"
        ></generic-sync-v2-priorities>
      </div>
    </div>
  </div>
</template>

<script>
import BaseSelectVisible from "../../tables/base-select-visible.vue";
import SyncTable from "./generic-sync-v2-table.vue";
import Priorities from "./generic-sync-v2-priorities.vue";

export default {
  name: "generic-sync-v2",
  components: {
    "base-select-visible": BaseSelectVisible,
    "generic-sync-v2-table": SyncTable,
    "generic-sync-v2-priorities": Priorities,
  },
  props: {
    channelId: {
      required: true,
      type: Number,
    }
  },
  mounted() {
    this.$events.$on("per-page", (eventData) => this.doVisibleSet(eventData));
  },
  data() {
    return {
      perPage: 10,
      moreParams: {},
      css: {
        table: {
          tableClass: "table table-middle table-minimal",
          ascendingIcon: "sort-icon-asc",
          descendingIcon: "sort-icon-desc",
          infoClass: "",
        },
      },
      amountsShown: [
        { text: "10", value: 10 },
        { text: "25", value: 25 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
      ],
    };
  },
  methods: {
    doVisibleSet(perPageValue) {
      this.perPage = perPageValue;
    },
  },
};
</script>